import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { apps } from "@/data/products";
import { LEGAL_EN } from "@/data/legalEn";
import { LEGAL_ES } from "@/data/legalEs";
import { useLang } from "@/context/LangContext";
import { Eyebrow, FadeUp } from "@/components/Reveal";
import { Markdown } from "@/components/Markdown";

export default function AppLegalPage({ kind }) {
  const { slug } = useParams();
  const { t, lang, localizePath } = useLang();
  const app = apps.find((a) => a.slug === slug);
  if (!app || (kind !== "privacy" && kind !== "terms")) return <Navigate to={localizePath("/")} replace />;

  const docs = lang === "es" && LEGAL_ES[slug] && LEGAL_ES[slug][kind] ? LEGAL_ES[slug] : LEGAL_EN[slug];
  const text = docs[kind];
  const label = kind === "privacy" ? t("legalPage.privacy") : t("legalPage.terms");

  return (
    <div data-testid={`legal-${kind}-${slug}`} className="bg-paper pt-28 md:pt-36">
      <div className="mx-auto max-w-3xl px-5 pb-24 md:pb-32">
        <FadeUp>
          <Link
            to={localizePath(`/app/${app.slug}`)}
            data-testid="back-to-app"
            className="group inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.25em] text-ink/50 transition-colors hover:text-cobalt"
          >
            <ArrowLeft className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-x-0.5" />
            {app.name}
          </Link>
        </FadeUp>
        <FadeUp delay={0.1}>
          <div className="mt-8 flex items-center gap-4">
            <img src={app.icon} alt="" className="h-12 w-12 rounded-[22%] border border-ink/10" />
            <Eyebrow>{label}</Eyebrow>
          </div>
        </FadeUp>
        <FadeUp delay={0.15} amount={0.05}>
          <div data-testid="legal-document" className="mt-10">
            <Markdown text={text} />
          </div>
        </FadeUp>
      </div>
    </div>
  );
}
